import React, { useState } from "react";
import "./RecentPosts.css";
import { FaCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const recentPosts = [
  {
    id: 1,
    date: "Nov 18, 2024",
    title: "Assured Life Mortality Table is currently 80% complete",
    image: "images/News/news1.jpg",
    link: "/LatestNews_1",
  },
  {
    id: 2,
    date: "Nov 19, 2021",
    title: "A look at regulations of financial services",
    image: "images/News/news2.jpg",
    link: "/LatestNews_2",
  },
  {
    id: 3,
    date: "Jun 13, 2022",
    title: "GSS, actuaries to develop National Mortality Table",
    image: "images/News/news3.jpeg",
    link: "/LatestNews_3",
  },
  {
    id: 4,
    date: "Jun 14, 2022",
    title: "Government collaborates with insurance and pension regulators",
    image: "images/News/news4.jpeg",
    link: "/LatestNews_4",
  },
  {
    id: 5,
    date: "May 15, 2023",
    title: "Insurance industry urged to support development of actuarial science professionals",
    image: "images/News/news2.jpg",
    link: "/LatestNews_5",
  },
];

function RecentPosts() {
  const [selectedId, setSelectedId] = useState(null);

  const handlePostClick = (id) => {
    setSelectedId(id);
  };

  return (
    <div className="recent-posts">
      <h2 className="recent-posts-heading">Recent Post</h2>
      <ul className="recent-posts-list">
        {recentPosts.map((post) => (
          <li
            key={post.id}
            className={`recent-post ${
              selectedId === post.id ? "recent-post-selected" : ""
            }`}
          >
            <Link
              to={post.link}
              onClick={() => handlePostClick(post.id)}
            >
              <img
                src={post.image}
                alt={post.title}
                className="recent-post-image"
              />
            </Link>
            <div className="recent-post-content">
              <p className="recent-post-date">
                <FaCalendarAlt className="calendar-icon" /> {post.date}
              </p>
              <Link
                to={post.link}
                onClick={() => handlePostClick(post.id)}
                className="recent-post-title-link"
              >
                <h3 className="recent-post-title">{post.title}</h3>
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RecentPosts;
